// Single source of truth for contact & conversion wiring.
export const WHATSAPP_NUMBER = "919150990892";
export const WHATSAPP_DISPLAY = "91509 90892";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const MESSAGES = {
  home: "Hi Anjum, I visited the Disign Digital website and would like to know more about getting a website for my business.",
  generic: "Hi Anjum, I would like to discuss a website for my business.",
  pricing:
    "Hi Anjum, I am interested in your website packages and would like to discuss which one is right for my business.",
};

export const CONTACT = {
  name: "Anjum Kauser",
  role: "Business Growth Expert at Disign Digital",
};

export const BRAND = {
  name: "Disign Digital",
  tagline: "Digital Presence. Real Business.",
  domain: "disigndigital.me",
  logo: "/assets/logo.jpg",
};

export const NAV_LINKS = [
  { label: "Home", href: "#top" },
  { label: "Website Demos", href: "#demos" },
  { label: "Why Website?", href: "#why-website" },
  { label: "Services", href: "#services" },
  { label: "Pricing", href: "#pricing" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
